import { useEffect } from "react";

interface Props {
  step: number,
  totalSteps: number
}

const stepLabels = [
  'Identification',
  'App. Info',
  'Applicant',
  'Demographics',
  'Legal Rep.',
  'Review',
  'Documents',
  'Signature'
];

function ApplicationProgressBarComponent(props: Props) {
  useEffect(() => {
    document.title = `BDS Gateway - Step ${props.step}/${props.totalSteps}`;
  })

  return (
    <div className="bds-step-progress">
      <div className="bds-stepper" role="list" aria-label="Application progress">
        {Array.from({ length: props.totalSteps }, (_, i) => i + 1).map((n) => {
          const isCompleted = n < props.step;
          const isActive = n === props.step;
          const label = stepLabels[n - 1] ?? `Step ${n}`;
          return (
            <div
              key={n}
              className={`bds-step${isCompleted ? ' completed' : ''}${isActive ? ' active' : ''}`}
              role="listitem"
              aria-current={isActive ? 'step' : undefined}
            >
              <div className="bds-step-circle" aria-hidden="true">
                {isCompleted ? <span>&#10003;</span> : <span>{n}</span>}
              </div>
              <div className="bds-step-label">{label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export const ApplicationProgressBar = ApplicationProgressBarComponent;
